/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Box, Grid, Typography } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import Modal from "../../../components/common/Modal/Modal";
import Loader from "../../../components/common/Loader/Loader";
import Styles from "./Styles";
import Dropdown from "../../../components/common/new/Dropdown/Dropdown";
import InputField from "../../../components/common/new/InputField/InputField";
import { AlertStatus } from "../../../contants";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import Button from "../../../components/common/Button";
import Files from "../../../services/api/files";
// import Emailer from "../../../services/api/emailer";

const FILE_CAT = [
  { key: "Appointment forms", value: "APPOINTMENT_FORM" },
  { key: "BSG Songs", value: "SONG" },
  { key: "Introduction forms", value: "INTRODUCTION_FORM" },
  { key: "SBTG Visit", value: "SBTG_VISIT" },
  { key: "BDS Guide", value: "BDS_GUIDE" },
];

function UpdateModal({
  open,
  onClose,
  selectedDocument,
  setAttachments,
  attachments,
  onRefresh,
}) {
  const toast = useContext(ToastAlertContext);
  const [attachmentsData, setAttachmentsData] = useState([]);
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");

  useEffect(() => {
    if (selectedDocument) {
      setName(selectedDocument.name || "");
      setCategory(selectedDocument.category || "");
    }
  }, [selectedDocument]);

  const [isLoading, setIsLoading] = useState(false);
  const attachmentInputRef = useRef(null);

  const handleCancel = () => {
    setAttachmentsData([]);
    onClose();
  };

  const handleAttachments = async (event) => {
    const allowedFileTypes = [
      "application/msword",
      "application/vnd.ms-excel",
      "application/pdf",
      "text/plain",
      "text/csv",
      "application/xml",
      "text/xml",
      "image/png",
      "image/webp",
      "image/jpeg",
      "application/zip",
      "application/gzip",
      "application/x-zip-compressed",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/x-7z-compressed",
      "application/vnd.google-apps.document",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.google-apps.kix",
      "application/vnd.google-apps.form",
      "application/vnd.google-apps.presentation",
      "application/vnd.google-apps.spreadsheet",
    ];

    const file = event.target.files[0];
    if (file) {
      if (!allowedFileTypes.includes(file.type)) {
        toast.show("Selected file format is not supported", AlertStatus.ERROR);
        return;
      }

      try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await Files.uploadFileAttachments({
          data: formData,
        });
        if (response.code === 200) {
          const { data } = response;
          toast.show("File Attached Successfully", AlertStatus.SUCCESS);
          setAttachmentsData((prevAttachmentsData) => [
            ...prevAttachmentsData,
            data,
          ]);
          setAttachments((prevAttachments) => [...prevAttachments, data.id]);
        }
      } catch (error) {
        toast.show(
          "Error uploading file. Please try again.",
          AlertStatus.ERROR
        );
      }
    } else {
      toast.show("No file selected.", AlertStatus.ERROR);
    }
  };

  const handleButtonAttach = () => {
    attachmentInputRef.current.click();
  };
  const handleRemoveAttachment = (attachmentIndex, attachmentId) => {
    setAttachmentsData((prevAttachments) =>
      prevAttachments.filter((_, index) => index !== attachmentIndex)
    );
    setAttachmentsData((prevAttachments) =>
      prevAttachments.filter((ide) => ide !== attachmentId)
    );
    setAttachments((prevAttachments) =>
      prevAttachments.filter((ide) => ide !== attachmentId)
    );
  };

  const validateDocument = () => {
    if (!name || name === "") {
      toast.show("Please enter document name ", AlertStatus.ERROR);
      return false;
    }

    if (!category || category === "") {
      toast.show("Please enter document category", AlertStatus.ERROR);
      return false;
    }
    if (attachments.length === 0) {
      toast.show(
        "Please make sure to attach at least one file for the document",
        AlertStatus.ERROR
      );
      return false;
    }

    return true;
  };

  const handleButtonClick = async () => {
    try {
      setIsLoading(true);
      if (!validateDocument()) {
        setIsLoading(false);
        return;
      }
      await Files.updateFiles(
        {
          name,
          category,
          fileIds: attachments,
        },
        selectedDocument?.id
      );
      toast.show("Document uploaded Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        onRefresh();
        handleCancel();
      }, 2000);
      setIsLoading(true);
    } catch (error) {
      setIsLoading(false);
      toast.show(
        "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      customStyle={{ maxHeight: "90%", minWidth: "30%" }}
    >
      {isLoading && <Loader />}
      <div>
        <Box>
          <Typography
            style={{
              color: "#8C8C8C",
              fontSize: "20px ",
              fontWeight: "500",
            }}
          >
            Upload File
          </Typography>
          <Box marginTop="30px" color="#183053">
            <Typography />
          </Box>
          <Box>
            {" "}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Grid item md={8} sm={12}>
                <div style={{ padding: "20px 0px 0px 10px" }}>
                  <div style={{ ...Styles.gridContainer }}>
                    <div style={{ ...Styles.gridItem }}>
                      <InputField
                        label="Document Name"
                        name="name"
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                        required
                      />
                    </div>

                    <div style={{ ...Styles.gridItem }}>
                      <Dropdown
                        required
                        name="category"
                        value={category}
                        options={FILE_CAT}
                        label="Document Category"
                        onChange={(event) => setCategory(event.target.value)}
                        showCross
                        handleClearValue={() => {
                          setCategory("");
                        }}
                      />
                    </div>
                    <div>
                      <div
                        onClick={handleButtonAttach}
                        style={Styles.attachments}
                      >
                        <AttachFileIcon sx={{ cursor: "pointer" }} />
                        <p style={{ cursor: "pointer", margin: "0 0" }}>
                          Attachments
                        </p>
                      </div>
                      <input
                        type="file"
                        onChange={handleAttachments}
                        ref={attachmentInputRef}
                        style={{ display: "none" }}
                      />
                    </div>
                    <div style={{ ...Styles.gridItem }}>
                      {attachmentsData?.length > 0 && (
                        <ul style={{ margin: "0 0", paddingLeft: "0px" }}>
                          {attachmentsData?.map((attachment, index) => (
                            <div style={Styles.attachmentsLists}>
                              <li style={Styles.attachmentsListsItems}>
                                <p style={Styles.textContainer}>
                                  {attachment?.originalFileName}
                                </p>
                                <ClearIcon
                                  onClick={() =>
                                    handleRemoveAttachment(
                                      index,
                                      attachment?.id
                                    )
                                  }
                                  style={{ cursor: "pointer" }}
                                />
                              </li>
                            </div>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              </Grid>
            </div>
          </Box>
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 10,
              marginTop: "20px",
            }}
          >
            <Button
              variant="contained"
              onClick={handleButtonClick}
              label="Save"
            />
            <Button variant="outlined" onClick={handleCancel} label="Cancel" />
          </Box>
        </Box>
      </div>
    </Modal>
  );
}

export default UpdateModal;
